module.exports = __webpack_public_path__ + "static/GT-America-Compressed-Medium-Italic-d22e7209b399fd7559b78338361d3f62.woff";